const SET_TOAST = 'SET_TOAST';

export const setToast = toast => ({
  type: SET_TOAST,
  payload: typeof toast === 'string' ? { title: toast } : toast
});

const initialState = {
  /**
   *  @object containing information for toast
   *  @object.title
   *  @object.body
   */
  toast: null
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOAST:
      return { ...state, toast: action.payload };
    default:
      return state;
  }
};
